import React from 'react'
import { i18nTranslate, isExpressCheckout } from 'src/utils'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { APPConfig, getBuyNowInPDP, IS_BROWSER } from 'config/appConfig'
import { catalogContainer, customerContainer } from 'src/models'
import { ProductSimilar } from 'src/views/components/ProductComponents'

@observer
class RecommendedProducts extends React.Component {
  @observable recommendedProducts = {}
  constructor(props) {
    super(props)
    this.titles = this.getDefaultCarouselTitle()
    this.defaultRecommendationType = 'productsAlsoViewed'
    this.isToEnableAWSRecommendation = false
  }

  getDefaultCarouselTitle = () => {
    return {
      productsAlsoViewed: i18nTranslate(
        'recommendedProducts.customersViewedTitle',
        'Customers also viewed',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      getAwsMostPopularProducts: i18nTranslate(
        'pdp.youMayAlsoLike',
        'You may also like',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      myRecommendedProducts: i18nTranslate(
        'pdp.recommendedproducts',
        'Recommended Products',
        {
          nameSpace: 'ssr-resource',
        }
      ),
    }
  }

  componentDidMount() {
    this.checkAndMakeRecommendedProducts()
  }

  checkAndMakeRecommendedProducts = options => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    const isToEnableProductPromotionAPI =
      APPConfig?.getAppConfig()?.enableProductPromotionAPI == 'true' || false
    if (IS_BROWSER) {
      if (customerResponse?.id) {
        this.getAWSRecommendedProducts()
      } else {
        // used timer since we don't have direct connection between customer and product state
        setTimeout(() => {
          this.checkAndMakeRecommendedProducts(options)
        }, 300)
      }
    }
  }

  getAWSRecommendedProducts = async () => {
    if (
      APPConfig?.getAppConfig?.()?.enableAWSRecommendation == 'true' &&
      customerContainer.isRegisterUser
    ) {
      this.isToEnableAWSRecommendation = true
    }

    if (this.isToEnableAWSRecommendation) {
      this.recommendedProducts = await catalogContainer.getAWSRecommendations({
        skuId: this.props?.product?.skuId,
        recommendationType:
          this.props?.recommendationType || this.defaultRecommendationType,
        limitItemsAfterFilter: 10,
      })
    } else if (this.props.product?.crossSellProducts) {
      this.recommendedProducts.product = this.props.product.crossSellProducts
    }
  }

  render() {
    const title =
      this.props?.title ||
      this.titles[
        this.props?.recommendationType || this.defaultRecommendationType
      ] ||
      ''
    const className = this.isToEnableAWSRecommendation
      ? 'aws-recommended-products'
      : isExpressCheckout() && !getBuyNowInPDP()
      ? 'express-recommended-products'
      : 'recommended-products'
    return (
      <div className={className}>
        <ProductSimilar
          title={title}
          product={{
            crossSellProducts: this.recommendedProducts?.product,
          }}
          isToEnableAWSRecommendation={this.isToEnableAWSRecommendation}
        />
      </div>
    )
  }
}

export { RecommendedProducts }
